import { render, staticRenderFns } from "./GroupSupportsModal.vue?vue&type=template&id=4cd213c0&scoped=true&"
import script from "./GroupSupportsModal.vue?vue&type=script&lang=js&"
export * from "./GroupSupportsModal.vue?vue&type=script&lang=js&"
import style0 from "./GroupSupportsModal.vue?vue&type=style&index=0&id=4cd213c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd213c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog,VIcon})
